import { prepareAuthHeaders } from '../requestsHelper';
import { useApi } from '../useApi';
import { baseUrl, ServiceName } from '../urlHelper';

import { CONSTANTS_PATH } from '../constant';


export const useGetOfferListAPI = () => {
    const { apiCall } = useApi();

    const getOfferList = async ( requestId: string): Promise<any> => {
        const url: string = `${baseUrl(ServiceName.REQUESTS)}${CONSTANTS_PATH.OFFERS}/request/${requestId}`;

        return await apiCall<any>(url, {
            method: 'GET',
            headers: {
                ...prepareAuthHeaders(),
            },
        });
    };

    return { getOfferList };
};
